import { useQuery } from '@apollo/client';
import { DoctorById } from 'gql/profile/__generated__/DoctorById';
import { GET_DOCTOR_PROFILE } from 'gql/profile/queries';
import { useAuthStateContext } from 'providers/Auth';
import { useMemo } from 'react';

type Params = {
  lang: string;
};

const useDoctorProfileCache = ({ lang }: Params) => {
  const { user } = useAuthStateContext();

  const { data } = useQuery<DoctorById>(GET_DOCTOR_PROFILE, {
    nextFetchPolicy: 'cache-only',
    variables: {
      id: user?.id,
      lang
    }
  });

  const profile = useMemo(() => data?.doctorById.data, [data?.doctorById.data]);

  return { profile };
};

export default useDoctorProfileCache;
